import { useLocation, useNavigate } from 'react-router-dom';
import { wordDetail, wordSave, trans } from './api'; // 确保这些 API 可用
import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

export default function WordEdit() {
    const location = useLocation();
    const navigate = useNavigate();

    // 从 location.state 中获取传递过来的 wordDetailId
    const { wordDetailId } = location.state || {};

    // 状态：记录当前编辑的单词 ID 和详情数据
    const [id, setId] = useState(wordDetailId || null);
    const [detail, setDetail] = useState({ word: '', translate: '' });

    // 获取单词详情
    const getDetail = async () => {
        try {
            const result = await wordDetail(id); // 直接传递 id
            console.log("detail=", result);
            setDetail(result);
        } catch (err) {
            console.error("加载单词详情出错:", err);
        }
    };

    // 初始化加载详情
    useEffect(() => {
        if (id) {
            console.log("init, id:", id)
            getDetail(id);
        }
    }, [id]);

    // 保存单词修改
    const handleSave = async () => {
        try {
            await wordSave({ id, ...detail }); // 将 ID 和详情一起提交
            console.log('保存成功');
            navigate('/wordList');
        } catch (err) {
            console.error("保存单词出错:", err);
        }
    };

    // 保存并新建
    const handleSaveAndNew = async () => {
        try {
            await wordSave({ id, ...detail });
            console.log('保存成功，准备新建');
            setId(null);
            setDetail({ word: '', translate: '' }); // 清空当前编辑框
        } catch (err) {
            console.error("保存单词出错:", err);
        }
    };

    const translate = async () => {
        try {
            const tranResult = await trans({ word: detail.word }); // 修正变量名
            console.log('trans=', tranResult)
            setDetail({ ...detail, translate: tranResult.translate }); // 保持其他字段不变
        } catch (err) {
            console.error("翻译单词出错:", err);
        }
    }

    return (
        <Grid container spacing={2} sx={{ justifyContent: 'center', mt: 2 }}>
            {/* 编辑框 */}
            <Grid item xs={12} md={8}>
                <TextField
                    id="word-edit"
                    label="Word"
                    value={detail.word}
                    onChange={(e) => setDetail({ ...detail, word: e.target.value })}
                    multiline
                    maxRows={4}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} md={8}>
                <TextField
                    id="translate-edit"
                    label="Translation"
                    value={detail.translate}
                    onChange={(e) => setDetail({ ...detail, translate: e.target.value })}
                    multiline
                    maxRows={4}
                    fullWidth
                />
            </Grid>

            {/* 按钮 */}
            <Grid item xs={12} md={8} container spacing={2} justifyContent="center">
                <Grid item>
                    <Tooltip title="Save changes">
                        <Button variant="contained" color="primary" onClick={handleSave}>
                            Save
                        </Button>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Tooltip title="Return to list">
                        <Button variant="outlined" onClick={() => navigate('/wordList')}>
                            Return to List
                        </Button>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Tooltip title="Save and add a new word">
                        <Button variant="contained" color="secondary" onClick={handleSaveAndNew}>
                            Save and New
                        </Button>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Tooltip title="Translation">
                        <Button variant="contained" color="secondary" onClick={translate}>
                            Translation
                        </Button>
                    </Tooltip>
                </Grid>
            </Grid>
        </Grid>
    );
}
